import { TYPES, ErrorMessages } from '../../common/constants';
import * as client from '../../services/client';
import { setPropertyWalkThroughFormData} from '../actions/propertyWalkThroughForm'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { startFormLoading, startPRLoading, stopFormLoading, stopPRLoading } from './loader';
import { setValidation } from './validation';
import { fetchSuiteCounts } from './suites';
import { ToastFail } from '../../helpers/validationHelper';

let feedbackURL=localStorage.getItem('IsHomerNavigatFromFeedBackTemplate');
let homeOwnerIsRedirectFromEmailTemplateURL=window.location.href;
if(feedbackURL==null ||  feedbackURL==undefined || feedbackURL=="" ){
  localStorage.removeItem('IsHomerNavigatFromFeedBackTemplate');
  let url= new URL(homeOwnerIsRedirectFromEmailTemplateURL);
  let URLparams = new URLSearchParams(url.search);
  if(URLparams.has('isShowFeedBackReportPopup') && URLparams.has('ServiceRequestId')){
   let ServiceRequestId= URLparams.get('ServiceRequestId');
   localStorage.setItem('IsHomerNavigatFromFeedBackTemplate',JSON.stringify({IsHomerNavigatFromFeedBackTemplate:true,ServiceRequestId:ServiceRequestId}))
   }
}
const saveFaqsNotesDocumentsDone = payload => ({
  type: TYPES.SAVE_FAQ_NOTES_DOCUMENTS_DONE,
  payload,
});

const convert = (str) => {
  if(str === 'FAQS'){
    str = str.substring(0,str.length - 1)
    return str
  } else if(str === 'MAINTENANCEGUIDE') {
    str = 'Maintenance reminder'
    return str
  }else{
    str = str.charAt(0) + str.substring(1).toLowerCase();
    str = str.substring(0,str.length - 1) 
    return str;
  }
  

}

export const saveFaqsNotesDocuments = (data,type,propertyWalkThroughFormData) => dispatch => {
  dispatch(startFormLoading())
  let Type = convert(data.Type)
  
  // let  res = Type.charAt(0) + Type.substring(1).toLowerCase();
  return client.addFaqsNotesDocuments(data).then(
    response => {
      dispatch(stopFormLoading())
      if (response.ok || response.status === 200) {
        response.json().then(
          responsejson => {
            toast.success( 'ⓘ  '+Type + ' has been added.',{autoClose:10000,position:'top-center'})
            dispatch(setValidation('FaqDocNotes'))
            dispatch(saveFaqsNotesDocumentsDone(responsejson.data))
            if(type && type  === 'addInFaqWalkThrough'){
              let data = responsejson.data;
              let parsedData = JSON.parse(data.data);
              
              let FAQDetails = propertyWalkThroughFormData.walkthroughFAQDetails;
              
              let faq = { 
                id:data.id,
                question:parsedData.question,
                answer:parsedData.answer
              }
              FAQDetails = [ ...FAQDetails,faq]
              dispatch(
                setPropertyWalkThroughFormData({
                  walkthroughFAQDetails:FAQDetails
                })
              )
            }
            if(type && type === "Suite") {
              dispatch(fetchSuiteCounts(data.ItemId, data.Role))
            }
          }
        )
      } else {
        ToastFail(Type + ' adding failed, please try again.');
      }
    }).catch(() => {
      ToastFail(ErrorMessages.error);
      dispatch(stopFormLoading())
    })
};

const updateFaqsNotesDocumentsDone = payload => ({
  type:TYPES.UPDATE_FAQ_NOTES_DOCUMENTS_DONE,
  payload
})

export const clearFaqsNotesDocuments = () => ({
  type: TYPES.CLEAR_FAQ_NOTES_DOCUMENTS
})
export const updateFaqsNotesDocuments = (data) => dispatch => {
  dispatch(startFormLoading())
  let Type = convert(data.Type)
  // let res = Type.charAt(0) + Type.substring(1).toLowerCase();
  // delete data.Type;
  // delete data.Name
  return client.updateFaqsNotesDocuments(data).then(
    response => {
      dispatch(stopFormLoading())
      if(response.ok || response.status === 200){
        response.json().then(
          responsejson => {  
            dispatch(setValidation('FaqDocNotes'))          
            toast.success('ⓘ  '+Type+ ' has been updated.',{autoClose:10000,position:'top-center'})
            dispatch(updateFaqsNotesDocumentsDone(responsejson.data))
          }
        )
      } else {
        ToastFail(Type + ' updating failed, please try again.');
      }
    }).catch(() => {
      ToastFail(ErrorMessages.error);
      dispatch(stopFormLoading())
    })
}

const deleteFaqsNotesDocumentsDone = payload =>({
  type:TYPES.DELETE_FAQ_NOTES_DOCUMENTS_DONE,
  payload

})
export const deleteFaqsNotesDocuments = (data, extraInfo) => dispatch => {
  let Type = convert(data.Type)
  // let res = Type.charAt(0) + Type.substring(1).toLowerCase();
  return client.deleteFaqsNotesDocuments(data.id).then(
    response => {
      if(response.ok || response.status === 200){
        response.json().then(
          responsejson => {
            toast.success('ⓘ   ' +Type+ ' has been deleted.',{autoClose:10000,position:'top-center'})
            dispatch(deleteFaqsNotesDocumentsDone(data.id))
            if(extraInfo && extraInfo.type === "Suite") {
              dispatch(fetchSuiteCounts(extraInfo.suiteId, extraInfo.role));
            }
          }
        )
      } else {
        ToastFail(Type + ' delete failed, please try again.');
      }
    }).catch(() => {
      ToastFail(ErrorMessages.error);
    })
}


export const fetchFaqsNotesDocumentsDone = payload => ({
  type: TYPES.FETCH_FAQS_NOTES_DOCUMENTS_DONE,
  payload,
});
const fetchLatestVideosDone = payload => ({
  type: TYPES.FETCH_VIDEOS_DONE,
  payload
})
export const clearFaqsNotesDocumentsDone = () => ({
  type: TYPES.CLEAR_FAQ_NOTES_DOCUMENTS
});
export const faqsNotesDone = payload => ({
  type: TYPES.FETCH_NOTES,
  payload
});

export const clearNotes =() => ({
  type: TYPES.CLEAR_NOTES,
  
});


export const fetchFaqsNotesDocuments = (assetId,itemdata,loader) => dispatch => {
  // return client.fetchFaqsNotesDocuments(id)
  if(loader === false) {
  } else {
    dispatch(startPRLoading())
  }
  return client.fetchFaqsNotesDocumentForAssetByAssetId(assetId,itemdata ? itemdata : 'itemdata1')
    .then(
      response => {
        if (response.ok || response.status === 200) {
          response.json().then(
            responsejson => { 
            dispatch(fetchFaqsNotesDocumentsDone(responsejson))
            dispatch(faqsNotesDone(responsejson))
            dispatch(stopPRLoading())
            })
        } else {
          dispatch(stopPRLoading())
          // alert('Something Went Wrong')
        }
      }


    );
};

export const fetchFaqsNotesDocumentForAssetByAssetId = (assetId,itemdata) => dispatch => {
  client.fetchFaqsNotesDocumentForAssetByAssetId(assetId,itemdata).then(response=>{
    if(response.status === 200 || response.ok){
      response.json().then( responsejson => {
        let data = [];
        // if(responsejson.length > 0){
        //   data = responsejson.filter( a => a.type === 'NOTES' || a.type === 'DOCUMENTS');
        // }
        // console.log('response form fetchFaqsNotesDocumentForAssetByAssetId---->',responsejson,data);
        dispatch(fetchFaqsNotesDocumentsDone(responsejson));
      })
    }
  })
}

const fetchServiceRequestFaqsNotesDocumentsDone = payload => ({
  type: TYPES.FETCH_FAQS_NOTES_DOCUMENTS_DONE,
  payload,
});

export const fetchServiceRequestFaqsNotesDocuments = id => dispatch => {
  dispatch(startPRLoading())
  return client.fetchServiceRequestFaqsNotesDocuments(id)
    .then(
      response => {
        if (response.ok || response.status === 200) {
          response.json().then(
            responsejson => { 
            dispatch(fetchServiceRequestFaqsNotesDocumentsDone(responsejson))
            dispatch(faqsNotesDone(responsejson))
            dispatch(stopPRLoading())
            })
        } else {
          dispatch(stopPRLoading())
          // alert('Something Went Wrong')
        }
      }


    );
};

const fetchMaintenanceGuideForAssetByItemIdDone = payload => ({
  type: TYPES.FETCH_MAINTENANCE_GUIDE_FOR_ASSET_BY_ITEM_ID_DONE,
  payload,
});

export const fetchMaintenanceGuideForAssetByItemId = id => dispatch => {
  return client.fetchFaqsNotesDocuments(id)
    .then(
      response => {
        if (response.ok || response.status === 200) {
          response.json().then(
            responsejson => { 
              
                let maintenanceGuideList = responsejson.filter( fndm => fndm.type === 'MAINTENANCEGUIDE')
              
                dispatch(fetchMaintenanceGuideForAssetByItemIdDone(maintenanceGuideList))
              // dispatch(fetchFaqsNotesDocumentsDone(responsejson)) 
            }
            )
        } else {
          // alert('Something Went Wrong')
        }
      }


    );

}

export const fetchLatestFaqsNotesDocuments = (id, type) => dispatch => {
  return client.fetchLatestFaqsNotesDocuments(id)
    .then(
      response => {
        if (response.ok || response.status === 200) {
          response.json().then(
            responsejson => {
            dispatch(fetchFaqsNotesDocumentsDone(responsejson))
            if(type === 'MaintenanceGuide') {
              dispatch(fetchMaintenanceGuide(id));
            }
            })
        } else {
          // alert('Something Went Wrong')
        }
      }
    );
};

export const onFetchLatestVideos = (id) => dispatch => {
  return client.onFetchLatestVideos(id)
    .then(
      response => {
        if (response.ok || response.status === 200) {
          response.json().then(
            responsejson => {
              dispatch(fetchLatestVideosDone(responsejson))
            })
        } else {
          // alert('Something Went Wrong')
        }
      }
    );
};


export const fetchMaintenanceGuide = id => dispatch => {
  return client.fetchMaintenanceGuide(id)
    .then(
      response => {
        
        if (response.ok || response.status === 200) {
          response.json().then(
            responsejson => {   
                dispatch(fetchMaintenanceGuideForAssetByItemIdDone(responsejson))
            }
            )
        } else {
          // alert('Something Went Wrong')
        }
      }
    );
}

const fetchFaqsForAssetByItemIdDone = payload => ({
  type: TYPES.FETCH_FAQS_FOR_ASSET_BY_ITEM_ID_DONE,
  payload,
});


export const fetchFaqsForAssetByItemId = (id) => dispatch => {
  return client.fetchFaqsNotesDocuments(id).then(response => {
    if(response.status === 200) {
      response.json().then(responsejson => {
        let faqsList = responsejson.filter( fndm => fndm.type === 'FAQS')                                 
        dispatch(fetchFaqsForAssetByItemIdDone(faqsList))        
      })
    } else {

    }
  })
}
// 



export const deleteOnboardingDocument = (data) => dispatch => {
  let Type = convert(data.Type)
    return client.deleteOnboardingDocument(data.id, data.userId).then(response => {
      if(response.status === 200) {
        response.json().then(responsejson => {
          toast.success('ⓘ   ' +Type+ ' has been deleted.',{autoClose:10000,position:'top-center'})
          dispatch(deleteFaqsNotesDocumentsDone(data.id))
        })
      } else {
        toast.error('ⓘ   ' +Type+ ' deleting failed.',{autoClose:2000,position:'top-center'})  
      }
    }).catch(() => {
      toast.error('ⓘ   ' +Type+ ' deleting failed.',{autoClose:2000,position:'top-center'})  
    })
}